
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { BaseLayout } from '@/components/templates';
import { withUrql } from '@/config/graphql';
import { contentfulClient } from '@cms/client';
import { GameGuideFragment, GamingGuidesOverviewPageDocument, } from '@cms/graphql/gamingGuidesOverviewPage.generated';
import { ImageLinkBox, LinkBoxList, TextualHero, Node, ImageLinkBoxProps, } from '@meritcircle/ui/components';
import { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next';
import { useRouter } from 'next/router';
import { canonicalUrl as getCanonicalUrl } from '@/utils/seo';
import { Seo } from '@/components/utils/seo/seo-component';
import { Container, Heading } from '@chakra-ui/react';
import { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { GamingGuidesOverviewPageProps } from '@/components/features/academy/academy.types';
import { getGamingGuideUrl } from '@/utils/gaming-guides';
import { getBadgeVariant, isGameNew } from '@/utils/games';
import useTranslation from 'next-translate/useTranslation';
import { getOpenGraphProps } from '@/components/utils/seo/get-open-graph-props';
const subtitleOptions: Options = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node: Node, children: string) => (<Heading size="xs" variant={'glowing'} lineHeight={'1.4'} color="white">
        {children}
      </Heading>)
    }
};
const formatGameTiles = (games: GameGuideFragment[]): ImageLinkBoxProps[] => games.map(({ sys, title, urlSlug, mainImage, gameTagsCollection }) => {
    const newBadge = isGameNew(sys.firstPublishedAt) && { name: 'New' };
    return {
        title,
        image: {
            src: `${mainImage.url}?w=400`,
            placeholderUrl: `${mainImage.url}?w=400`
        },
        badges: [...gameTagsCollection.items, newBadge].filter(Boolean).map(tag => ({
            children: tag.name,
            variant: getBadgeVariant(tag.name)
        })),
        href: getGamingGuideUrl(urlSlug)
    };
});
const translateGameBadges = (linkBox: ImageLinkBoxProps, findLabel: string, replaceLabel: string): ImageLinkBoxProps => ({
    ...linkBox,
    badges: linkBox.badges.map(badge => ({
        ...badge,
        children: badge.children.toString().replace(findLabel, replaceLabel)
    }))
});
type PageProps = InferGetServerSidePropsType<typeof getServerSideProps>;
const Page: NextPage<PageProps> = ({ title, subtitle, metaTitle, metaDescription, ogImage, noFollow, noIndex, keywords, linkedSeoTags, gameGuides, }) => {
    const router = useRouter();
    const { t } = useTranslation('common');
    const canonicalUrl = getCanonicalUrl(router);
    return (<BaseLayout>
      <Seo title={linkedSeoTags?.title || metaTitle || title} description={linkedSeoTags?.description || metaDescription} nofollow={linkedSeoTags?.noFollow || noFollow} noindex={linkedSeoTags?.noIndex || noIndex} keywords={linkedSeoTags?.keywords || keywords} canonical={canonicalUrl} openGraph={getOpenGraphProps({
            title: linkedSeoTags?.title || metaTitle || title,
            description: linkedSeoTags?.description || metaDescription,
            url: canonicalUrl,
            image: ogImage
        })}/>

      <TextualHero title={title} subtitle={subtitle.json} subtitleOptions={subtitleOptions}/>

      <Container>
        <Heading mb={8} as="h2" size="h3">
          All guides
        </Heading>
        <LinkBoxList mb={16}>
          {gameGuides.map((gameGuide, index) => (<ImageLinkBox {...translateGameBadges(gameGuide, 'New', t('labels.new'))} key={index}/>))}
        </LinkBoxList>
      </Container>
    </BaseLayout>);
};
const getServerSideProps: GetServerSideProps<GamingGuidesOverviewPageProps> = async () => {
    const overviewPage = await contentfulClient.query(GamingGuidesOverviewPageDocument).toPromise();
    const pageContent = await overviewPage.data?.pageGamingGuidesOverviewCollection.items[0];
    const gameGuides = await overviewPage.data?.pageGameCollection.items;
    if (!pageContent) {
        console.log('👻 gaming guides page data is missing');
        return {
            notFound: true
        };
    }
    if (!gameGuides) {
        console.log('👻 game guides data is missing');
        return {
            notFound: true
        };
    }
    const { title, subtitle, linkedSeoTags, metaTitle, metaDescription, ogImage, noFollow, noIndex, keywords, } = pageContent;
    return {
        props: {
            title,
            subtitle,
            linkedSeoTags,
            metaTitle,
            metaDescription,
            ogImage,
            noFollow,
            noIndex,
            keywords,
            gameGuides: formatGameTiles(gameGuides),
            lastUpdate: `${new Date()}`
        }
    };
};
export default withUrql(Page);

    async function __Next_Translate__getServerSideProps__1973b3b2bf5__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/gaming-guides/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1973b3b2bf5__ as getServerSideProps }
  